module.exports = __webpack_public_path__ + "static/media/tribal-dance.459771a8.jpg";